module.exports = __webpack_public_path__ + "static/media/CL 4.afd1ff56.mp3";